export const EhrRecordsControllerFactory = ({
  ehrRecordsService,
}: {
  ehrRecordsService: IEhrRecordsService;
}) => {
  const getEhrMedications: IGetEhrMedicationsController = async (obj) =>
    ehrRecordsService.getEhrMedications({
      clinic_id: obj.clinic_id,
      patient_id: obj.patient_id,
      status: obj.status,
      limit: obj.limit,
      offset: obj.offset,
    });

  const getEhrNutrition: IGetEhrNutritionController = async (obj) =>
    ehrRecordsService.getEhrNutrition({
      clinic_id: obj.clinic_id,
      patient_id: obj.patient_id,
      status: obj.status,
      limit: obj.limit,
      offset: obj.offset,
    });

  const getEhrAssessments: IGetEhrAssessmentsController = async (obj) =>
    ehrRecordsService.getEhrAssessments({
      clinic_id: obj.clinic_id,
      patient_id: obj.patient_id,
      assessment_status: obj.assessment_status,
      assessment_type: obj.assessment_type,
      limit: obj.limit,
      offset: obj.offset,
    });

  const getEhrAllergies: IGetEhrAllergiesController = async (obj) =>
    ehrRecordsService.getEhrAllergies({
      clinic_id: obj.clinic_id,
      patient_id: obj.patient_id,
      status: obj.status,
      category: obj.category,
      clinical_status: obj.clinical_status,
      limit: obj.limit,
      offset: obj.offset,
    });

  const getEhrLabs: IGetEhrLabsController = async (obj) =>
    ehrRecordsService.getEhrLabs({
      clinic_id: obj.clinic_id,
      patient_id: obj.patient_id,
      report_type: obj.report_type,
      report_status: obj.report_status,
      limit: obj.limit,
      offset: obj.offset,
    });

  return {
    getEhrMedications,
    getEhrNutrition,
    getEhrAssessments,
    getEhrAllergies,
    getEhrLabs,
  };
};
